/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { taxPayment } from '@/api/ajax';
export const invoiceStatus = [
  {
    name: '审批中',
    key: 1
  },
  {
    name: '已驳回',
    key: 2
  },
  {
    name: '已通过',
    key: 3
  }
];
export default [
  {
    id: 'gys',
    key: 'selectBoxId',
    tip: '请输入供应商',
    required: false,
    slot: 'ajaxSelect',
    clearable: true,
    ajax: taxPayment.selectBox,
    prop: {
      label: 'enterpriseName',
      code: 'id'
    },
    query: {
      type: 1
    },
    ajaxQuery: 'keyWord',
    width: 180
  },
  {
    id: 'kfqy',
    key: 'selectBoxName',
    tip: '请输入客户企业',
    required: false,
    slot: 'ajaxSelect',
    clearable: true,
    ajax: taxPayment.selectBox,
    prop: {
      label: 'showEnterpriseName',
      code: 'enterpriseName'
    },
    query: {
      type: 2
    },
    ajaxQuery: 'keyWord',
    width: 180
  },
  {
    width: 180,
    id: 'status',
    key: 'auditStatus',
    slot: 'select',
    tip: '审批状态',
    clearable: true,
    required: false,
    options: invoiceStatus
  },
  {
    width: 180,
    id: 'monthrange',
    tip: '请选择完税月份',
    key: 'proofMonth',
    clearable: true,
    required: false,
    slot: 'date',
    format: 'yyyy-MM',
    rangeValue: []
  }
];
